export interface TimesheetPath {
  chips: string[]
  description: string
  title: string
}
